import { Controller } from 'react-hook-form';

import AddressAutocomplete from '@/components/address-autocomplete';
import { Countries } from '@/utils/common';

import type { CreateOrderFormType } from '../create-order-schema';
import type { AddressInputRef } from './use-address-input';
import type { RefObject } from 'react';
import type { Control, UseFormSetValue } from 'react-hook-form';

import { useAddressInput } from './use-address-input';

interface AddressInputProps {
  control: Control<CreateOrderFormType>;
  name: 'origin' | 'destination';
  findAddressComponent: (
    components: google.maps.GeocoderAddressComponent[],
    type: string,
  ) => string;
  setValue: UseFormSetValue<CreateOrderFormType>;
  ref?: RefObject<AddressInputRef | null>;
  country?: Countries;
  onZipCodeNotFound?: (notFound: boolean) => void;
}

const AddressInput = (props: AddressInputProps) => {
  const hooks = useAddressInput(props);

  return (
    <Controller
      name={`${props.name}.address`}
      control={props.control}
      render={({ field, fieldState: { error } }) => (
        <AddressAutocomplete
          id={`${props.name}-location-search`}
          value={field.value || hooks.inputValue}
          country={props.country || 'MEX'}
          onChange={(newVal) => {
            field.onChange(newVal);
            hooks.onChangeInputValue(newVal);
          }}
          onSelectAddress={(details) => {
            field.onChange(details.address);
            hooks.onAddressSelect(details);
          }}
          error={!!error}
          helperText={error?.message}
          label="Dirección"
          placeholder="Dirección"
          size="small"
          fullWidth
          sx={{ width: '100%', mt: '0.5rem' }}
        />
      )}
    />
  );
};

export default AddressInput;
export type { AddressInputRef };
